import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * Converts all requests to authentication provider to local requests
   * so that they are proxied to avoid CORS issues when deployed
   *
   * @param req the request being made
   * @param next the next request handler in the chain
   * @returns the HTTP event
   */
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Make all OAuth requests local to enable reverse proxy to avoid CORS issue with PingFederate when deployed
    if (req.url.includes(environment.provider)) {
      const originalURL = req.url;
      const requestToForward = req.clone({
        url: originalURL.replace(environment.provider, window.location.origin),
      });
      return next.handle(requestToForward);
    } else {
      return next.handle(req);
    }
  }
}
